// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1854":"af0ad172","2084":"7e38c056","6154":"89eeceef","9892":"7a194c5a"}[chunkId] + ".chunk.css";
};